import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { errorText, dropdownArrow, dropdownArrowIsOpen } from './SelectInput.scss';

class SelectInput extends Component {
  arrowRenderer({ isOpen }) {
    const isOpenCss = isOpen ? dropdownArrowIsOpen : '';
    return (
      <svg className={dropdownArrow + ' ' + isOpenCss} xmlns="http://www.w3.org/2000/svg" width="13" height="8" viewBox="0 0 13 8">
        <path fill="none" fillRule="evenodd" stroke="#2F2E2E" d="M12.657 1L7 6.657 1.343 1" />
      </svg>
    );
  }

  handleElementCreated(element) {
    this.selectElement = element;
    if (typeof this.props.onElementCreated === 'function') {
      this.props.onElementCreated(element);
    }
  }

  handleKeyDown({ keyCode }) {
    switch (keyCode) {
      case 32: // space
      case 13: // enter
        if (this.selectElement && !this.selectElement.state.isOpen) {
          this.selectElement.focusNextOption();
        }
        break;

      default:
        break;
    }
  }

  render() {
    const props = this.props;
    const { source, selectedValue, error, id } = props;

    return (
      <div>
        <Select
          {...props}
          ref={element => this.handleElementCreated(element)}
          className={'checkout-select ' + (error ? 'error' : '')}
          options={source}
          value={selectedValue}
          arrowRenderer={this.arrowRenderer}
          onInputKeyDown={e => this.handleKeyDown(e)}
        />
        {error ? (
          <div id={`${id}_desc`} className={errorText}>
            {error}
          </div>
        ) : null}
      </div>
    );
  }
}

SelectInput.propTypes = {
  id: PropTypes.any,
  onElementCreated: PropTypes.any,
  source: PropTypes.any,
  wrapperStyle: PropTypes.any,
  selectedValue: PropTypes.any,
  onChange: PropTypes.func,
  placeholder: PropTypes.any,
  error: PropTypes.any
};

export default SelectInput;
